export default "__VITE_ASSET__Dz6ZHOh2__"